/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AclroleAr } from '../../models/aclrole-ar';

export interface GetUserRoles$Params {
  orid: number;
}

export function getUserRoles(http: HttpClient, rootUrl: string, params: GetUserRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AclroleAr>>> {
  const rb = new RequestBuilder(rootUrl, getUserRoles.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AclroleAr>>;
    })
  );
}

getUserRoles.PATH = '/getuserroles/{orid}';
